// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"a150999c","453":"d5a14a85","455":"bcb5a4d0"}[chunkId] + ".chunk.js";
};